import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { InputControllerTypes } from 'common/enums';
import { DetailInfo } from 'common/model';
import { FormArray, FormGroup, FormControl } from '@angular/forms';
import { parseRepeatableTableColumns } from 'shared/shared.helper';
import { IRepeatableGridColumn } from '../detail-info-repeatable-table/detail-info-repeatable-table.component';

@Component({
  selector: 'app-detail-info-type-container',
  templateUrl: './detail-info-type-container.component.html',
  standalone: false
})
export class DetailInfoTypeContainerComponent {
  @Input() detailInfo!: DetailInfo;
  @Input() formGroup!: FormGroup;
  @Input() hideLabel = false;
  @Input() gridView = false;
  @Input() noDefaultValue = false;

  public ControllerTypes = InputControllerTypes;

  // RepeatableTable fields: columns parsed once from the field's JSON descriptors.
  private _tableColumns?: IRepeatableGridColumn[];

  control(guid: string): FormControl {
    return this.formGroup.get(guid) as FormControl;
  }

  get tableColumns(): IRepeatableGridColumn[] {
    if (!this._tableColumns) {
      this._tableColumns = parseRepeatableTableColumns(this.detailInfo);
    }
    return this._tableColumns;
  }

  rowsArray(guid: string): FormArray {
    return this.formGroup.get(guid) as FormArray;
  }
}
